import { render, staticRenderFns } from "./withdrawal-list.vue?vue&type=template&id=b585efb8&scoped=true&"
import script from "./withdrawal-list.vue?vue&type=script&lang=js&"
export * from "./withdrawal-list.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal-list.vue?vue&type=style&index=0&id=b585efb8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b585efb8",
  null
  
)

export default component.exports